import React, { useState } from 'react';
import { Checkbox, List, Modal, Button } from 'antd';
import { pull } from 'lodash';
import PropTypes from 'prop-types';
import { downloadFileFromURI, makeApiRequestAndHandleError } from 'common/utils/http';
import { ATTRIBUTE_TYPE_PROPTYPE } from 'common/constants/commonPropTypes';
import { clone } from 'common/utils/generic';

const propTypes = {
  attribute_types: PropTypes.arrayOf(ATTRIBUTE_TYPE_PROPTYPE).isRequired,
  fields: PropTypes.arrayOf(PropTypes.string).isRequired,
  toggle: PropTypes.func.isRequired,
  selectedFields: PropTypes.arrayOf(PropTypes.string).isRequired,
  setSelectedFields: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired,
  ids: PropTypes.arrayOf(PropTypes.number).isRequired,
};

export const exportCsv = async (ids, toggle, selectedFields, download) => {
  const downloadURI = `/api/v1/multi-people-attributes?ids=${ids.join(',')}&fields=${selectedFields.join(',')}`;
  makeApiRequestAndHandleError(
    () => download(downloadURI, `${Date.now()}-Export.csv`, 'csv'),
    () => Modal.error({
      content: 'There was an error trying to export the attributes. Please try logging in again.',
      title: 'Error',
      onOk: () => { window.location.href = '/' },
    })
  );
  toggle();
};

const FieldsPickerModal = ({ attribute_types, fields, ids, isOpen, toggle, selectedFields, setSelectedFields }) => {
  const [selectedAll, setSelectedAll] = useState(false);
  const onToggle = item => {
    const mutableSelectedFields = clone(selectedFields);
    if (!mutableSelectedFields.includes(item)) {
      mutableSelectedFields.push(item);
    } else {
      pull(mutableSelectedFields, item);
    }
    setSelectedFields(mutableSelectedFields);
  };

  const onToggleSelectAll = () => {
    if (selectedAll) {
      setSelectedFields([]);
    } else {
      const immutableAttr = clone(fields);
      setSelectedFields(immutableAttr);
    }
    setSelectedAll(!selectedAll);
  };

  return (
    <Modal
      bodyStyle={{ maxHeight: '500px', display: 'block', overflow: 'auto' }}
      footer={[
        <Button key="export" onClick={() => exportCsv(ids, toggle, selectedFields, downloadFileFromURI)} type="primary">
          Export as CSV
        </Button>,
      ]}
      onCancel={toggle}
      open={isOpen}
      title="Select Output Columns"
    >
      <Checkbox
        checked={fields.length === selectedFields.length}
        onChange={onToggleSelectAll}
        style={{ marginTop: '30px', marginBottom: '15px' }}
      >
        Select All
      </Checkbox>
      <List
        dataSource={fields}
        renderItem={item => (
          <List.Item key={item.id}>
            <Checkbox
              checked={selectedFields.includes(item)}
              onChange={() => onToggle(item)}
              style={{ paddingRight: '15px' }}
            />
            <>[{item}] {attribute_types.find(type => type.name === item).description}</>
          </List.Item>
        )}
      />
    </Modal>
  );
};
FieldsPickerModal.propTypes = propTypes;
export default FieldsPickerModal;
